<template lang="pug">
  v-layout.column.content-card.scroll-y-overflow(v-rc-loader="loading")
    v-card.mb-4.grey.lighten-4.pb-4
      span.style-category-title.mb-3
        v-layout.justify-space-between.align-end.grey.lighten-5.pl-2.pb-2.mb-3
          span.font-weight-bold.title.primary--text Ma clé d'API TouristicMaps
          v-btn.mr-4(@click="copyToClipboard(apiKey.api_key)" fab small dark color="primary")
            v-icon(color="white") file_copy
        v-snackbar(v-model="copiedSnackbar" bottom right :timeout="2000" color="primary")
          |La clé d'API à été copiée dans votre presse-papier
      span.title.pl-2(data-test="userApiKey") {{ apiKey.api_key }}
    v-card.mt-4.mb-4
      span.style-category-title.mb-3.mt-4
        v-layout.justify-space-between.align-end.grey.lighten-5.pl-2.pb-2
          span.font-weight-bold.title.primary--text Sites internet autorisés à utiliser ma clef API
          v-dialog.mr-3(persistent width="50%" v-model="open")
            v-btn.mt-2(
              fab small dark
              color="primary"
              slot="activator"
              data-test="openNewDomainDialog"
            )
              v-icon(medium color="white") add
            v-card
              v-card-title.primary
                v-layout.justify-center
                  v-flex.xs1
                  v-flex.xs10.text-xs-center
                    .headline.white--text.font-weight-bold AUTORISER UN NOUVEAU DOMAINE
                  v-flex.xs1.text-xs-right
                    v-icon(@click="open = false" dark large) close
              v-card-text
                .erreur-zoom(v-if="erreurZoom") La valeur du champ est incorect
                v-text-field(
                  label="Nouveau domaine"
                  data-test="authorizedDomainField"
                  v-model="newDomainName"
                )
                v-layout.justify-end
                  v-btn(color="primary" data-test="addAuthorizedDomain" @click="addDomain") Ajouter
      div.authorizedDomain(
        data-test="authorizedDomain"
        v-for="domain in apiKey.additionals_domains" :key="domain.domain"
      )
        v-layout.justify-space-between.pa-4
          span.title {{ domain }}
          v-icon.pr-2(data-test="deleteAuthorizedDomain" @click="deleteDomain(domain)") delete
    v-card.mt-4
      v-flex.text-color
        span.style-category-title.mb-3.mt-4
          v-layout.justify-space-between.align-end.grey.lighten-5.pl-2.pb-2.pt-4
            span.font-weight-bold.title.primary--text Sites internet autorisés automatiquement par RaccourciAgency
        v-flex
          div.userDomain(
            data-test="userDomain"
            v-for="domain in apiKey.authorized_domains" :key="domain.domain"
          )
            v-layout.justify-space-between.pa-4
              span.title {{ domain }}
</template>

<script>
export default {
  data() {
    return {
      newDomainName: '',
      open: false,
      copiedSnackbar: false,
      loading: true,
      erreurZoom: false,
    };
  },
  methods: {
    copyToClipboard(text) {
      const dummy = document.createElement('input');
      document.body.appendChild(dummy);
      dummy.setAttribute('value', text);
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      this.copiedSnackbar = true;
    },
    async addDomain() {
      this.loading = true;
      if (this.newDomainName && RegExp('^[a-zA-Z0-9.-]*$').test(this.newDomainName)) {
        this.open = false;
        this.erreurZoom = false;
        await this.$store.dispatch('permissions/addDomain', [this.newDomainName]);
        await this.$store.dispatch('permissions/getApiKey');
      } else {
        this.erreurZoom = true;
      }
      this.loading = false;
    },
    async deleteDomain(id) {
      this.loading = true;
      await this.$store.dispatch('permissions/deleteDomain', id);
      await this.$store.dispatch('permissions/getApiKey');
      this.loading = false;
    },
  },
  mounted() {
    this.$store.dispatch('permissions/getApiKey').then(() => { this.loading = false; });
  },
  computed: {
    apiKey() {
      return this.$store.state.permissions.apiKey;
    },
  },
};
</script>

<style lang="scss" scoped>
  .authorizedDomain {
    &:nth-of-type(2n-1) {
      background-color: #ddd;
    }
    &:nth-of-type(2n) {
      background-color: #f8f8f8;
    }
  }
  .userDomain {
    &:nth-of-type(2n-1) {
      background-color: #ddd;
    }
    &:nth-of-type(2n) {
      background-color: #f8f8f8;
    }
  }
  .text-color{
    color: grey;
  }

  .erreur-zoom{
    font-family: Roboto,sans-serif;
    color: #FF2222 ;
    font-weight: bold;
    margin-bottom: 14px;
    font-style: italic;
    text-align: center;
  }
</style>
